export default [{
  path: '/board/:boardId',
  component: () => import('./BoardView'),
  children: [
    { path: '/board/:boardId/card/:cardId', component: () => import('@/app/board/shared/components/card/Card'), name: 'viewcard' }
  ],
  name: 'board',
  meta: {
    resource: 'boards',
    actions: ['read']
  }
}]
